export default __webpack_public_path__ + "static/media/typec.e3d4284e.png";